export function passwordStrength(pw: string): number {
  return (
    (/.{8,}/.test(pw) ? 1 : 0) /* at least 8 characters */ *
    ((/[a-z]/.test(pw) ? 1 : 0) /* a lower letter */ +
      (/[A-Z]/.test(pw) ? 1 : 0) /* a upper letter */ +
      (/\d/.test(pw) ? 1 : 0) /* a digit */ +
      (/[^A-Za-z0-9]/.test(pw) ? 1 : 0)) /* a special character */
  );
}

export const disableStartDate = (values: any, name?: any) => (current: any) => {
  const to = values[name];
  if (to) return current.clone().startOf('day').isAfter(to.clone().startOf('day'));
};

export const disableEndDate = (values: any, name?: any) => (current: any) => {
  const from = values[name];
  if (from) return current.clone().startOf('day').isBefore(from.clone().startOf('day'));
};

export const checkTime = (myTime: string) => {
  if (myTime.length === 4) {
    var h = myTime.substring(0, 2);
    var s = myTime.substring(2, 4);
    if (h > '23') {
      return false;
    }
    if (s > '59') {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

export const deleteKeyEmpty = (data: any) => {
  const dataClone = { ...data };
  // eslint-disable-next-line array-callback-return
  Object.keys(dataClone || {}).map((key) => {
    if (!dataClone[key] && dataClone[key] !== 0) {
      delete dataClone[key];
    }
  });
  return dataClone;
};

const isScreenInMenu = (item?: any, autority?: any) => {
  return autority?.some((itemMap: any) => {
    return (
      (item?.screenId &&
        item?.screenId?.includes(itemMap?.TRANS_SCREEN_ID) &&
        itemMap?.TRANS_SCREEN_ID !== itemMap?.SCREEN_ID) ||
      item?.displayByDefault ||
      item?.subMenu
    );
  });
};

export const convertAuthorityMenu = (data: any, autority: any) => {
  const authorityData = data
    .filter((item: any) => {
      return isScreenInMenu(item, autority);
    })
    ?.map((element: any) => {
      if (element?.subMenu) {
        return Object.assign({}, element, {
          subMenu: element.subMenu
            .filter((item: any) => {
              return isScreenInMenu(item, autority);
            })
            ?.map((elementSub: any) => {
              if (elementSub?.subMenu) {
                return Object.assign({}, elementSub, {
                  subMenu: elementSub.subMenu.filter((item: any) => {
                    return isScreenInMenu(item, autority);
                  }),
                });
              }
              return elementSub;
            }),
        });
      }
      return element;
    });

  const filterSubmennu = authorityData
    ?.map((item: any) => {
      if (item?.subMenu) {
        if (item?.subMenu?.length) {
          const sub = item?.subMenu
            .filter((subItem: any) => {
              if (subItem?.subMenu) {
                if (subItem?.subMenu?.length) {
                  return item;
                }
                return false;
              }
              return item;
            })
            .filter((si: any) => si);
          if (!sub.length) {
            return false;
          } else {
            item.subMenu = sub;
            return item;
          }
        }
        return false;
      }
      return item;
    })
    .filter((i: any) => i);

  return [...filterSubmennu];
};
